import { useState, useCallback, useEffect } from "react";

const STORAGE_KEY = "dora_recently_viewed";
const MAX_ITEMS = 10;

export const useRecentlyViewed = () => {
  const [items, setItems] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch { /* quota exceeded */ }
  }, [items]);

  const addViewed = useCallback((product) => {
    if (!product?.id) return;
    setItems((prev) => {
      const filtered = prev.filter((p) => p.id !== product.id);
      const entry = {
        id: product.id,
        name: product.name,
        price: product.price,
        image: product.image || product.imageUrl,
      };
      return [entry, ...filtered].slice(0, MAX_ITEMS);
    });
  }, []);

  return { recentlyViewed: items, addViewed };
};
